import './App.css';
import HomePage from './components/HomePage';
import ProductsList from './components/ProductsList';
import { Routes, Route } from 'react-router-dom';
import ProductDetails from './components/ProductDetails';
import Contact from './components/Contact';


function App() {

  return (
    <div className="App">
      <Routes>
       <Route path='/' element={<HomePage/>}/>
        <Route path='/products' element={<ProductsList/>}/> 
        <Route path='/products/:productId' element={<ProductDetails/>}/> 
        <Route path='/contact' element={<Contact/>}/> 
      </Routes>
    </div>
  );
}

export default App;
